export default "__VITE_ASSET__Bl7x4hhP__"